import type { EasingFn } from '@/animation/easing/easingFn'
import {
  backOut,
  bounceOut,
  easeInCubic,
  easeInOutCubic,
  easeOutCubic,
  linear,
} from '@/animation/easing/presets'
import type { EasingPreset } from '@/types/easingPreset'
import { isEasingPreset } from '@/types/easingPreset'

/**
 * 预设 id → 缓动函数（可扩展：新增 preset 时在此注册）。
 */
const easingByPreset: Record<EasingPreset, EasingFn> = {
  linear,
  'ease-in': easeInCubic,
  'ease-out': easeOutCubic,
  'ease-in-out': easeInOutCubic,
  'bounce-out': bounceOut,
  'back-out': backOut,
}

/**
 * @param preset - 预设 id；非法值时回退为 `linear`
 * @returns 对应的缓动函数
 */
export function getEasingForPreset(preset: string | undefined | null): EasingFn {
  if (preset != null && isEasingPreset(preset)) {
    return easingByPreset[preset]
  }
  return linear
}

/**
 * 供测试或动态注册扩展（未来高级 easing 可由此挂载）。
 *
 * @param preset - 预设 id
 * @param fn - 缓动实现
 */
export function registerEasingPreset(preset: EasingPreset, fn: EasingFn): void {
  easingByPreset[preset] = fn
}
